import { render, staticRenderFns } from "./booksDetail.vue?vue&type=template&id=5202c73c&scoped=true"
import script from "./booksDetail.vue?vue&type=script&lang=js"
export * from "./booksDetail.vue?vue&type=script&lang=js"
import style0 from "./booksDetail.vue?vue&type=style&index=0&id=5202c73c&prod&lang=css"
import style1 from "./booksDetail.vue?vue&type=style&index=1&id=5202c73c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202c73c",
  null
  
)

export default component.exports